var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLongArrowUpLeftwhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.21967 8.78033C5.92678 8.48744 5.92678 8.01256 6.21967 7.71967L9.71967 4.21967C10.0126 3.92678 10.4874 3.92678 10.7803 4.21967C11.0732 4.51256 11.0732 4.98744 10.7803 5.28033L7.81066 8.25L10.7803 11.2197C11.0732 11.5126 11.0732 11.9874 10.7803 12.2803C10.4874 12.5732 10.0126 12.5732 9.71967 12.2803L6.21967 8.78033Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 8.25C6 7.83579 6.33579 7.5 6.75 7.5L12.75 7.5C15.3734 7.5 17.5 9.62665 17.5 12.25V19.25C17.5 19.6642 17.1642 20 16.75 20C16.3358 20 16 19.6642 16 19.25L16 12.25C16 10.4551 14.5449 9 12.75 9L6.75 9C6.33579 9 6 8.66421 6 8.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLongArrowUpLeftwhite);
export default __webpack_public_path__ + "static/media/long-arrow-up-leftwhite.4fb622f28ead8362bad843dee974a12a.svg";
export { ForwardRef as ReactComponent };